import { CardImage } from "@sellar-io/components";
import { useDiscoverySuppliersByIdsList } from "../../../../hooks/api/v2/discovery/useDiscoverySupplierByIdsList";
import { useSellarCurrentBusiness } from "../../../../hooks/useSellarCurrentBusiness.shared";
import { useLocalStorage } from "usehooks-ts";
import { unAuthorisedUserPostcodeInLocalStorageKey } from "../../../discovery/v2/DiscoveryV2Home";
import { SpotlightSharedCardContainer } from "../../components/SharedCardComponents/SpotlightSharedCardContainer";
import { SpotlightSharedCardImageContainer } from "../../components/SharedCardComponents/SpotlightSharedCardImageContainer";
import { SupplierNameSection } from "./SupplierNameSection";

export const SpotlightBannerSupplier = ({
  supplierIds,
  onClick,
}: {
  supplierIds: number[];
  onClick?: () => void;
}) => {
  const { business } = useSellarCurrentBusiness();
  const [unAuthorisedUserPostcode] = useLocalStorage<string | undefined>(
    unAuthorisedUserPostcodeInLocalStorageKey,
    undefined,
  );
  const buyerPostcode =
    business?.type === "retailer"
      ? business.DeliveryAddress.postalCode
      : undefined;
  const supplierListQuery = useDiscoverySuppliersByIdsList({
    retailerPostcode: buyerPostcode,
    unAuthorisedUserPostcode,
    query: [
      {
        type: "id",
        modifier: "IN",
        value: supplierIds,
      },
    ],
    limit: 3,
    orderBy: "random",
  });

  const supplierList =
    supplierListQuery.data?.pages.flatMap((page) => page) ?? [];
  return (
    <>
      {supplierList.map((supplier) => (
        <SpotlightSharedCardContainer key={supplier.id} onClick={onClick}>
          <SpotlightSharedCardImageContainer className={"h-[120px] rounded-lg"}>
            <CardImage
              imageUrl={supplier.imageUrl ?? ""}
              fallback="supplier-hero"
              className={"h-[120px] w-[200px]"}
            />
          </SpotlightSharedCardImageContainer>
          <SupplierNameSection
            supplierLogo={supplier.Business.logoUrl ?? ""}
            supplierName={supplier.Business.name}
          />
        </SpotlightSharedCardContainer>
      ))}
    </>
  );
};
